<template>
  <div class="bg" v-show="show">
    <div class="wrapper">
      <div class="top">
          <div class="l"></div>
          <div class="r">
            <div class="t">{{ msg.title }}</div>
            <div class="b">将被推送至{{ msg.column }}</div>
          </div>
      </div>
      <div class="bottom">
        <div @click="confirm" class="btn g">确定通过</div>
        <div @click="cancel" class="btn">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'confirm',
  data() {
    return {
      show: true,
      msg: '',
      r: null,
      isSelected: false
    }
  },
  methods: {
    open(m, r) {
      console.log(r)
      this.msg = m
      this.r = r
      this.show = true
    },
    close() {
      this.show = false
    },
    confirm() {
      this.r(true)
      this.close()
    },
    cancel() {
      this.r(false)
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.70);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1222;
  }
  .wrapper {
    min-height: 170px;
    width: 472px;
    background-color: @bg;
    box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.15);
    border-radius: 4px;
    z-index: 99998;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    padding: 30px 32px 24px;

    .top {
      display: flex;
      flex-direction: row;

      .l {
        width: 22px;
        height: 22px;
        background: url('./assets/alert.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        margin-right: 16px;
      }

      .r {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        .t {
          font-size: 16px;
          color: #41B48C;
          font-weight: bold;
        }

        .b {
          color: #323B4B;
          font-size: 16px;
          line-height: 28px;
          font-weight: bold;
        }
      }
    }

    .bottom {
      display: flex;
      justify-content: flex-end;

      .btn {
        width: 80px;
        height: 32px;
        background: #B9C3C3;
        color: #FFF;
        font-weight: bold;
        font-size: 14px;
        line-height: 32px;
        text-align: center;
        border-radius: 4px;
        user-select: none;
        cursor: pointer;

        &.g {
          background: #41B48C;
          margin-right: 8px;
        }
      }
    }
  } 
</style>
